import classNames from 'classnames';
import { ChangeEvent, FocusEvent, ForwardedRef, useEffect, useRef } from 'react';

import { mergeRefs } from '../../lib/utils';

import styles from '../../styles/fields/date-field.module.css';

interface DateFieldProps {
    type?: 'date' | 'text';
    name?: string | null;
    value?: string | null;
    min?: number | string | null;
    max?: number | string | null;
    placeholder?: string | null;
    errors?: string[] | null;
    withBorder?: boolean;
    className?: string | null;
    onChange?: ((value: string | null) => void) | null;
    onFocus?: ((e: FocusEvent<HTMLInputElement>) => void) | null;
    onBlur?: ((e: FocusEvent<HTMLInputElement>) => void) | null;
}

function DateField({
    type = 'date',
    name = null,
    value = null,
    min = null,
    max = null,
    placeholder = null,
    errors = null,
    withBorder = false,
    className = null,
    onChange = null,
    onFocus = null,
    onBlur = null,
    ref: inputRef = null,
}: DateFieldProps & { ref?: ForwardedRef<HTMLInputElement> | null }) {
    const internalRef = useRef<HTMLInputElement>(null);
    const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        internalRef.current.setCustomValidity('');
        const newValue = e.currentTarget.value !== '' ? e.currentTarget.value : null;

        if (onChange !== null) {
            onChange(newValue);
        }
    };
    useEffect(() => {
        internalRef.current.setCustomValidity(
            errors !== null && errors.length > 0 ? errors[0] : '',
        );
        if (errors !== null && errors.length > 0) {
            internalRef.current.reportValidity();
        }
    }, [errors]);
    return (
        <input
            ref={mergeRefs(internalRef, inputRef)}
            type={type}
            name={name}
            value={value || ''}
            min={min}
            max={max}
            placeholder={placeholder}
            className={classNames([
                styles.container,
                {
                    [styles.withBorder]: withBorder,
                },
                className,
            ])}
            onChange={onInputChange}
            onFocus={onFocus}
            onBlur={onBlur}
        />
    );
}

export default DateField;
